import { animate, inView, stagger, timeline } from "motion";
import SplitType from 'split-type';

document.addEventListener('DOMContentLoaded', () => {

    // Split headings text into characters
    const heroSplit = new SplitType('.is-pattern-hero .wp-block-heading', { types: 'words' })
    const headersSplit = new SplitType('h2.wp-block-heading:not(.is-pattern-hero)', { types: 'words' })
    const buttonSplit = new SplitType('.wp-block-button a', { types: 'words' })

    // button hover

    const buttons = document.querySelectorAll('.wp-block-button')

        buttons.forEach(button => {
            button.addEventListener('mouseenter', function () {
                animate(button.querySelectorAll(".word"), { y: ['0','-3em']}, { delay: stagger( .05), duration: .5, easing: "ease-out" })
            });
    });



    // hero timeline on load

    timeline(
    [
        [".is-pattern-hero .word", { y: ['.5em', '0'], opacity: ["0","1"] }, { delay: stagger( .05 )}],
        [".is-pattern-hero .wp-block-button", { y: ['-100%', '0'], opacity: ['0', '1']}, { at: "<", duration: 1}],
        [".is-pattern-hero .wp-block-uagb-testimonial, header", { opacity: ['0', '1'] }, { at: "<", duration: 4}],
    ],
        { defaultOptions: { ease: [0.17, 0.55, 0.55, 1] }
    }).finished.then(() => {heroSplit.revert();});


    // Set initial values for inner sections

    var innerContainer = ".wp-block-cover__inner-container:not(.is-pattern-hero .wp-block-cover__inner-container)"
    animate(document.querySelectorAll(innerContainer), { opacity: 0 }, { duration: 0 })

    // Section - why

    inView("#why " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5,}],
            [target.querySelectorAll("p"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - approach

    inView("#approach " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            [target.querySelectorAll(".wp-block-details"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - deliverables

    inView("#deliverables " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            // [target.querySelector(".wp-block-uagb-slider"), { opacity: ["0","1"] }, { at: "<", duration: 2}, ],
            [target.querySelectorAll(".wp-block-uagb-slider-child"), { opacity: ["0","1"], x: [ "10%", "0" ] }, { at: "<", delay: stagger(0.1)}, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - who

    inView("#who " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            [target.querySelectorAll("p"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
            [target.querySelectorAll("img"), { opacity: ["0","1"], x: [".5em", "0"] }, { at: "-.75", delay: stagger(.05), duration: .5, }, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - work

    inView("#work " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            [target.querySelector(".wp-block-uagb-slider"), { opacity: ["0","1"] }, { at: "<", duration: 2}, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - contact

    inView("#contact " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            [target.querySelectorAll("p"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
            [target.querySelectorAll(".gfield"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
            [target.querySelector(".wp-block-uagb-testimonial"), { opacity: ["0","1"] }, { at:"-.1", duration: 2}, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

    // Section - faqs

    inView("#faqs " + innerContainer, ({ target }) => {
        timeline(
        [
            [target, { opacity: 1 }, { duration: .25,}, {at: ">"} ],
            [target.querySelectorAll(".wp-block-heading .word"), { opacity: ["0","1"], x: [".5em", "0"] }, { delay: stagger(.05), duration: .5, }, ],
            [target.querySelectorAll(".wp-block-details"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
            [target.querySelectorAll("p, .wp-block-buttons"), { opacity: ["0","1"] }, { at: "<", delay: stagger(.05), duration: 1, }, ],
        ],
            { defaultOptions: { ease: [0.17, 0.55, 0.55, 1]}
        }).finished.then(() => {SplitType.revert(target.querySelector(".wp-block-heading"));});
    }, {amount: .5});

})